import { useQuery } from '@tanstack/react-query';
import useJwt from '../../utils/useJwt';
import useLocaleQueryFilter from '../../utils/useLocaleQueryFilter';

export default function useFavorites() {
  const jwt = useJwt();
  const { licenseId, localeId } = useLocaleQueryFilter({ jwt });
  return useQuery<number[], Error>(
    ['favorites', { licenseId, localeId, jwt }],
    {
      enabled: !!jwt && !!licenseId && !!localeId,
    },
  );
}
